export default function firstValue(...values) {
  return values.find((value) => value !== undefined && value !== null && value !== "");
}
